import { useEffect } from "react";

/**
 * Lightweight SEO manager — sets document title, meta description,
 * canonical URL, Open Graph, and Twitter Card tags on route change.
 *
 * Why not react-helmet? Adds ~10kb and is unmaintained. This hook
 * is dependency-free, idempotent, and runs on the client after
 * React mounts each route component.
 */
function setMeta(name, content, attr = "name") {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  if (!href) return;
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SEO({
  title,
  description,
  canonical,
  ogImage = "https://tbirdgeo.com/og-image.jpg",
  ogType = "website",
  twitterCard = "summary_large_image",
}) {
  useEffect(() => {
    if (title) document.title = title;
    setMeta("description", description);
    setLink("canonical", canonical);

    // Open Graph
    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", ogType, "property");
    setMeta("og:url", canonical, "property");
    setMeta("og:image", ogImage, "property");
    setMeta("og:site_name", "Thunderbird Geospatial Inc.", "property");

    // Twitter
    setMeta("twitter:card", twitterCard);
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    setMeta("twitter:image", ogImage);
  }, [title, description, canonical, ogImage, ogType, twitterCard]);

  return null;
}
